export const useDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isIos = userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)
  const isAndroid = userAgent.match(/Android/i)
  const isMobile = !!(isIos || isAndroid)
  return {
    isIos, isAndroid, isMobile,
  }
}
